import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyLifeState, CompanyStateTimelineCompositeEntity } from '@nk/data-entities-lib';
import { DateFormats, Dict } from '@nk/utils-lib';
import { map, Observable } from 'rxjs';
import { CompanyLifeStateService } from '../../services/company-life-state.service';
import { COMPANY_LIFE_STATE_TRANSLATIONS, COMPANY_LIFE_STATES } from '../../utils/company-state.utils';
import { CompanyAnalysisRiskLayoutComponent } from '../company-analysis-risk-layout/company-analysis-risk-layout.component';
import { CompanyAnalysisRiskLoadingComponent } from '../company-analysis-risk-loading/company-analysis-risk-loading.component';
import { RiskLevelIconComponent } from '../risk-level-icon/risk-level-icon.component';

@Component({
  selector: 'nk-company-analysis-company-life-state-card',
  imports: [
    TranslateModule,
    AsyncPipe,
    DatePipe,
    CompanyAnalysisRiskLayoutComponent,
    CompanyAnalysisRiskLoadingComponent,
    RiskLevelIconComponent,
  ],
  templateUrl: './company-analysis-company-life-state-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyAnalysisCompanyLifeStateCardComponent implements OnInit {
  public companyUuid = input.required<string>();
  public companyLifeState = input.required<CompanyLifeState>();
  public companyLifeStateTranslations: Dict<string> = COMPANY_LIFE_STATE_TRANSLATIONS;
  public companyStateTimelineComposites$!: Observable<CompanyStateTimelineCompositeEntity[]>;
  public dateFormats = DateFormats;
  private _companyLifeStateService = inject(CompanyLifeStateService);

  public ngOnInit(): void {
    this.companyStateTimelineComposites$ = this.getCompanyStates(this.companyUuid());
  }

  public getCompanyStates(companyUuid: string): Observable<CompanyStateTimelineCompositeEntity[]> {
    return this._companyLifeStateService.companyStateTimelineCompositeByCompanyCache
      .get(companyUuid, null, null, Object.keys(COMPANY_LIFE_STATES))
      .pipe(
        map((items) =>
          items.sort(
            (a, b) =>
              b.company_state_timeline.active_from_date.valueOf() - a.company_state_timeline.active_from_date.valueOf(),
          ),
        ),
      );
  }
}
